import * as React from "react";
import {FormControl, InputLabel, MenuItem, Select, SelectChangeEvent} from "@mui/material";
import {useTranslate} from "@tolgee/react";

export function SelectCreditsButton(props: {
    maxValue: number,
    maxEnabled: number,
    selected: number,
    onSelect: (credits: number) => void
}) {
    const {t} = useTranslate();

    return (
        <FormControl size="small">
            <InputLabel id="demo-select-small-label">{t("credit_points")}</InputLabel>
            <Select
                labelId="demo-select-small-label"
                id="demo-select-small"
                value={props.selected.toString()}
                label={t("credit_points")}
                onChange={(event: SelectChangeEvent) => props.onSelect(parseFloat(event.target.value))}
            >
                {
                    Array.from(
                        {length: (props.maxValue * 2) + 1},
                        (_, i) => (i)).map(i => (
                        <MenuItem value={i/2} disabled={i/2 > props.maxEnabled} key={(i/2).toString()}>{(i/2).toString()}</MenuItem>
                    ))
                }
            </Select>
        </FormControl>)
}